import { getCategories } from '../../services/journal/categories.service'

// MF-67 — Journal categories list slice.
export const UPDATE_JOURNAL_CATEGORIES_LIST = 'UPDATE_JOURNAL_CATEGORIES_LIST'
export const TOGGLE_JOURNAL_CATEGORIES_LOADING = 'TOGGLE_JOURNAL_CATEGORIES_LOADING'
export const JOURNAL_CATEGORIES_ERROR = 'JOURNAL_CATEGORIES_ERROR'
export const JOURNAL_CATEGORIES_UPDATE_TOTAL = 'JOURNAL_CATEGORIES_UPDATE_TOTAL'

export const updateCategoriesList = (value = []) => ({
  type: UPDATE_JOURNAL_CATEGORIES_LIST,
  payload: { value }
})

export const categoriesError = (value = null) => ({
  type: JOURNAL_CATEGORIES_ERROR,
  payload: { value }
})

export const toggleLoadingCategories = (value = false) => ({
  type: TOGGLE_JOURNAL_CATEGORIES_LOADING,
  payload: { value }
})

export const updateTotalCategories = (value = 0) => ({
  type: JOURNAL_CATEGORIES_UPDATE_TOTAL,
  payload: { value }
})

export const loadCategories = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingCategories(true))
      dispatch(categoriesError())

      const { data } = await getCategories(params)

      dispatch(updateCategoriesList(data?.paginatedResults ?? []))
      dispatch(updateTotalCategories(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateCategoriesList([]))
      dispatch(updateTotalCategories(0))
      dispatch(categoriesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingCategories(false))
    }
  }
}
